import React, { useContext, useEffect } from "react";
import { Link, useParams, useNavigate } from 'react-router-dom';
import logoSmall from './../../../public/Images/logo.png';
import './menu.css';
import { AuthContext } from '../Context/auth.jsx';
import DashboardRH from "../../app/RhChamado/dashboard.jsx";


function Menu(props) {
    const navigate = useNavigate();
    const { setLogado } = useContext(AuthContext);
    const { id } = useParams();
    const chapa = localStorage.getItem("chapa");
    const AcessoSap = localStorage.getItem("SAPADM");
    // 🔹 Adicionado: Permissão de vendas lida do localStorage
    const permiteVendas = localStorage.getItem("permiteVendas");
    const permitePonto = localStorage.getItem("permitePonto");
    const permiteCheckList = localStorage.getItem("CHECKLIST");
    const permiteCadastroCheckTI = localStorage.getItem("TICADCHECKLIST");
    const permiteRegional = localStorage.getItem("permiteRegional") || localStorage.getItem("diretor");
    const permiteDashBoardRH = localStorage.getItem("RHDASHBOARD");
    console.log("flosoftnew " + permiteDashBoardRH);
    const isRestrito = chapa?.startsWith("90");

    //atendimento chamaod
    const permissoesChamado = JSON.parse(localStorage.getItem("setorchamado") || "[]");
    const permiteAtendimento = permissoesChamado.length > 0;

    useEffect(() => {
        const handler = (e) => {
            if (!e.target.closest(".navbar")) {
                document.querySelectorAll(".dropdown-menu.show")
                    .forEach(el => el.classList.remove("show"));
            }
        };

        document.addEventListener("click", handler);
        return () => document.removeEventListener("click", handler);
    }, []);

    function Logout() {
        setLogado(false);
        localStorage.clear();
    }

    const isSapOrArbor = props.modulo === "SAP" || props.modulo === "ARBOR" || chapa === '900010' || chapa === '900001';
    const hasAccessToTools = AcessoSap === "S" || chapa === '900010' || chapa === '900001';
    // 🔹 Adicionado: Variável para verificar acesso às vendas
    const hasAccessToVendas = AcessoSap === "S" || permiteVendas === "S";
    const isCheckCadastro = permiteCadastroCheckTI === "S";
    const itsChecklist = permiteCheckList === "S";
    const itsAcessoRegional = chapa === '900010' || chapa === '900001';
    const permiteConciliacao = localStorage.getItem("CONCILIACARTAO") === "S";

    return (
        <nav className="navbar fixed-top navbar-expand-md navbar-dark">
            <div className="container-fluid">
                <a aria-current="page" href="#">
                    <img className="logoarbor" src={logoSmall} alt="Rede Supermarket" title="Rede Supermarket" />
                </a>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent">
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul className="navbar-nav ms-auto">
                        {/* Menu REST */}
                        {!isRestrito && props.modulo === "REST" && (
                            <>
                                <li className="nav-item">
                                    <Link to={"/restaurante/avaliacao/"} className="nav-link"><i className="fa fa-star" /> Avaliações</Link>
                                </li>
                                <li className="nav-item">
                                    <Link to={"/restaurante/cardapio/"} className="nav-link"><i className="fa fa-pencil" /> Cardápio</Link>
                                </li>
                                <li className="nav-item">
                                    <Link to={"/restaurante/dados/"} className="nav-link"><i className="fa fa-address-card-o" /> Dados Cadastrais</Link>
                                </li>
                                {/*<li className="nav-item">
                                    <Link to="#" className="nav-link"><i className="fa fa-whatsapp" /> Extrato de Refeições</Link>
                                </li>*/}
                                <li className="nav-item">
                                    <Link to={"/restaurante/pedido/"} className="nav-link"><i className="fa fa-cutlery" /> Pedidos</Link>
                                </li>
                            </>
                        )}

                        {(!isRestrito && isSapOrArbor || itsAcessoRegional) && (
                            <li className="nav-item">
                                <Link to={"/arbor/home"} className="nav-link"><i className="fa fa-home" /> Principal</Link>
                            </li>
                        )}

                        {/* Menu Recursos Humanos (Autoatendimento) */}
                        {!isRestrito && isSapOrArbor && (
                            <li className="nav-item dropdown">
                                <a
                                    className="nav-link dropdown-toggle"
                                    href="#"
                                    role="button"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();

                                        const currentMenu = e.currentTarget.parentElement;
                                        const menu = e.currentTarget.nextElementSibling;

                                        // 🔥 fecha TODOS os outros menus principais
                                        document.querySelectorAll(".navbar .nav-item.dropdown").forEach((el) => {
                                            if (el !== currentMenu) {
                                                el.querySelector(".dropdown-menu")?.classList.remove("show");

                                                // fecha submenus também
                                                el.querySelectorAll(".dropdown-menu.show").forEach(sub => sub.classList.remove("show"));
                                                el.querySelectorAll(".dropdown-submenu").forEach(sub => sub.classList.remove("open-left"));
                                            }
                                        });

                                        // alterna o atual
                                        menu?.classList.toggle("show");
                                    }}
                                >
                                    Recursos Humanos
                                </a>
                                <ul className="dropdown-menu">
                                    <li className="dropdown-submenu">
                                        <a href="#" className="dropdown-item dropdown-toggle"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();

                                                const currentItem = e.currentTarget.parentElement;
                                                const submenu = e.currentTarget.nextElementSibling;

                                                // fecha TODOS os outros submenus (menos o atual)
                                                document.querySelectorAll(".dropdown-submenu").forEach((el) => {
                                                    if (el !== currentItem) {
                                                        el.classList.remove("open-left");
                                                        el.querySelector(".dropdown-menu")?.classList.remove("show");
                                                    }
                                                });

                                                // calcula espaço na tela
                                                const rect = e.currentTarget.getBoundingClientRect();
                                                const spaceRight = window.innerWidth - rect.right;

                                                // decide direção
                                                if (spaceRight < 250) {
                                                    currentItem.classList.add("open-left");
                                                } else {
                                                    currentItem.classList.remove("open-left");
                                                }

                                                // 🔥 IMPORTANTE: alterna só o atual
                                                submenu?.classList.toggle("show");
                                            }}
                                        >
                                            <i className="fa fa-user-plus" /> AEFLOR
                                        </a>
                                        <ul className="dropdown-menu">
                                            <li><Link to={"/arbor/aeflor/assistencia"} className="dropdown-item"><i className="fa fa-hand-holding-usd" /> Assistência Financeira</Link></li>
                                            <li><Link to={"/arbor/aeflor/convenio"} className="dropdown-item"><i className="fa fa-credit-card" /> Convênio</Link></li>
                                            <li><Link to={"/arbor/aeflor"} className="dropdown-item"><i className="fa fa-calendar" /> Eventos</Link></li>
                                        </ul>
                                    </li>
                                    <li><Link to={"/arbor/rh/chamado"} className="dropdown-item"><i className="fa fa-question-circle" /> Atendimento RH</Link></li>
                                    <li><Link to={"/arbor/atestado"} className="dropdown-item"><i className="fa fa-user-md" /> Atestados</Link></li>
                                    <li><Link to={"/arbor/escala/"} className="dropdown-item"><i className="fa fa-calendar" /> Escala de trabalho</Link></li>
                                    <li><Link to={"/arbor/holerite/"} className="dropdown-item"><i className="fa fa-envelope-o" /> Holerites</Link></li>
                                    <li><Link to={"/arbor/dadosfunc/"} className="dropdown-item"><i className="fa fa-address-card" /> Meus Dados</Link></li>
                                    <li><Link to={"/arbor/notificacoes/"} className="dropdown-item"><i className="fa fa-bell" /> Notificações</Link></li>
                                    <li><Link to={"/arbor/ponto/"} className="dropdown-item"><i className="fa fa-clock-o" /> Ponto</Link></li>
                                    <li><Link to={"/arbor/restaurante/"} className="dropdown-item"><i className="fa fa-check-square-o" /> Refeição</Link></li>
                                </ul>
                            </li>
                        )}

                        {/* Menu Ferramentas de Gestão */}
                        {isSapOrArbor && (
                            <li className="nav-item dropdown">
                                <a
                                    className="nav-link dropdown-toggle"
                                    href="#"
                                    role="button"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();

                                        const currentMenu = e.currentTarget.parentElement;
                                        const menu = e.currentTarget.nextElementSibling;

                                        // 🔥 fecha TODOS os outros menus principais
                                        document.querySelectorAll(".navbar .nav-item.dropdown").forEach((el) => {
                                            if (el !== currentMenu) {
                                                el.querySelector(".dropdown-menu")?.classList.remove("show");

                                                // fecha submenus também
                                                el.querySelectorAll(".dropdown-menu.show").forEach(sub => sub.classList.remove("show"));
                                                el.querySelectorAll(".dropdown-submenu").forEach(sub => sub.classList.remove("open-left"));
                                            }
                                        });

                                        // alterna o atual
                                        menu?.classList.toggle("show");
                                    }}
                                >
                                    Ferramentas
                                </a>
                                <ul className="dropdown-menu">
                                    {/* 3. SUBMENU CONTABILIDADE / FINANCEIRO */}
                                    {permiteConciliacao && (
                                        <li className="dropdown-submenu">
                                            <a
                                                href="#"
                                                className="dropdown-item dropdown-toggle"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();

                                                    const currentItem = e.currentTarget.parentElement;
                                                    const submenu = e.currentTarget.nextElementSibling;

                                                    // fecha TODOS os outros submenus (menos o atual)
                                                    document.querySelectorAll(".dropdown-submenu").forEach((el) => {
                                                        if (el !== currentItem) {
                                                            el.classList.remove("open-left");
                                                            el.querySelector(".dropdown-menu")?.classList.remove("show");
                                                        }
                                                    });

                                                    // calcula espaço na tela
                                                    const rect = e.currentTarget.getBoundingClientRect();
                                                    const spaceRight = window.innerWidth - rect.right;

                                                    // decide direção
                                                    if (spaceRight < 250) {
                                                        currentItem.classList.add("open-left");
                                                    } else {
                                                        currentItem.classList.remove("open-left");
                                                    }

                                                    // 🔥 IMPORTANTE: alterna só o atual
                                                    submenu?.classList.toggle("show");
                                                }}
                                            >
                                                <i className="fa fa-calculator" /> Contabilidade / Financeiro
                                            </a>

                                            <ul className="dropdown-menu">
                                                <li>
                                                    <Link to={"/arbor/fin/conciliacao"} className="dropdown-item">
                                                        <i className="fa fa-credit-card" /> Conciliação de Cartões
                                                    </Link>
                                                </li>
                                                {/* Você pode adicionar novos itens financeiros aqui no futuro */}
                                            </ul>
                                        </li>
                                    )}

                                    {/* 2. SUBMENU OPERAÇÕES LOJA (Ordenado) */}
                                    <li className="dropdown-submenu">
                                        <a href="#" className="dropdown-item dropdown-toggle"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();

                                                const currentItem = e.currentTarget.parentElement;
                                                const submenu = e.currentTarget.nextElementSibling;

                                                // fecha TODOS os outros submenus (menos o atual)
                                                document.querySelectorAll(".dropdown-submenu").forEach((el) => {
                                                    if (el !== currentItem) {
                                                        el.classList.remove("open-left");
                                                        el.querySelector(".dropdown-menu")?.classList.remove("show");
                                                    }
                                                });

                                                // calcula espaço na tela
                                                const rect = e.currentTarget.getBoundingClientRect();
                                                const spaceRight = window.innerWidth - rect.right;

                                                // decide direção
                                                if (spaceRight < 250) {
                                                    currentItem.classList.add("open-left");
                                                } else {
                                                    currentItem.classList.remove("open-left");
                                                }

                                                // 🔥 IMPORTANTE: alterna só o atual
                                                submenu?.classList.toggle("show");
                                            }}>
                                            <i className="fa fa-building" /> Operações Loja
                                        </a>

                                        <ul className="dropdown-menu">
                                            {/* Submenu de Chamados */}
                                            <li className="nav-item dropdown dropdown-submenu">
                                                <a
                                                    className="dropdown-item dropdown-toggle d-flex justify-content-between align-items-center"
                                                    href="#"
                                                    onClick={(e) => {
                                                        if (window.innerWidth < 992) {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            e.currentTarget.nextSibling.classList.toggle('show');
                                                        }
                                                    }}
                                                >
                                                    <span><i className="fa fa-ticket me-2" /> Chamados</span>
                                                </a>
                                                <ul className="dropdown-menu border-0 shadow-none ps-3">
                                                    <li>
                                                        <Link to={"/arbor/chamado"} className="dropdown-item">
                                                            <i className="fa fa-user me-2" /> Meus Chamados
                                                        </Link>
                                                    </li>
                                                    {permiteAtendimento && (
                                                        <li>
                                                            <Link to={"/arbor/chamado/atendimento"} className="dropdown-item">
                                                                <i className="fa fa-wrench me-2" /> Atendimento
                                                            </Link>
                                                        </li>
                                                    )}
                                                </ul>
                                            </li>
                                            {permiteVendas === 'S' && <li><Link to={"/arbor/produto/auditoria/"} className="dropdown-item"><i className="fa fa-cubes" /> Auditoria de produto</Link></li>}
                                            {isCheckCadastro && <li><Link to={"/arbor/checklist/cadastro/"} className="dropdown-item"><i className="fa fa-list" /> Cadastro Itens CheckList</Link></li>}
                                            {itsChecklist && <li><Link to={"/arbor/checklist/checklist/"} className="dropdown-item"><i className="fa fa-check-square-o" /> CheckList TI</Link></li>}
                                            {permiteRegional === 'S' && <li><Link to={"/arbor/equipamentos/admin"} className="dropdown-item"><i className="fa fa-cart-plus" /> Controle de Equipamentos ADMIN</Link></li>}
                                            {permiteVendas === 'S' && <li><Link to={"/arbor/equipamentos/"} className="dropdown-item"><i className="fa fa-shopping-cart" /> Controle de Equipamentos</Link></li>}
                                            <li><Link to={"/arbor/produto/"} className="dropdown-item"><i className="fa fa-barcode" /> Etiqueta</Link></li>
                                            {permiteRegional === 'S' && <li><Link to={"/arbor/loja/vistoria"} className="dropdown-item"><i className="fa fa-pencil-square-o" /> Vistoria - Checklist</Link></li>}
                                            {AcessoSap === "S" && <li><Link to={"/arbor/sap/"} className="dropdown-item"><i className="fa fa-money" /> SAP - Solicitação de Preços</Link></li>}
                                            <li><Link to={"/arbor/validade/"} className="dropdown-item"><i className="fa fa-calendar" /> Validade</Link></li>
                                        </ul>
                                    </li>

                                    {/* SUBMENU PESSOAS (Ordenado) */}
                                    <li className="dropdown-submenu">
                                        <a href="#" className="dropdown-item dropdown-toggle"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();

                                                const currentItem = e.currentTarget.parentElement;
                                                const submenu = e.currentTarget.nextElementSibling;

                                                // fecha TODOS os outros submenus (menos o atual)
                                                document.querySelectorAll(".dropdown-submenu").forEach((el) => {
                                                    if (el !== currentItem) {
                                                        el.classList.remove("open-left");
                                                        el.querySelector(".dropdown-menu")?.classList.remove("show");
                                                    }
                                                });

                                                // calcula espaço na tela
                                                const rect = e.currentTarget.getBoundingClientRect();
                                                const spaceRight = window.innerWidth - rect.right;

                                                // decide direção
                                                if (spaceRight < 250) {
                                                    currentItem.classList.add("open-left");
                                                } else {
                                                    currentItem.classList.remove("open-left");
                                                }

                                                // 🔥 IMPORTANTE: alterna só o atual
                                                submenu?.classList.toggle("show");
                                            }}>
                                            <i className="fa fa-users" /> Pessoas
                                        </a>
                                        <ul className="dropdown-menu">
                                            {permiteVendas === 'S' && <li><Link to={"/arbor/usuario/consinco/"} className="dropdown-item"><i className="fa fa-users" /> Associar Operador PDV</Link></li>}
                                            {permiteRegional === 'S' && <li><Link to={"/arbor/comunicado/"} className="dropdown-item"><i className="fa fa-address-book" /> Comunicação RH</Link></li>}
                                            {permiteVendas === 'S' && <li><Link to={"/arbor/rh/acidente/"} className="dropdown-item"><i className="fa fa-user-md" /> Comunicado de Ocorrência</Link></li>}
                                            {permiteDashBoardRH === "S" && <li><Link to="/arbor/rh/dashboard" className="dropdown-item"><i className="fa fa-deaf" /> DashBoard RH</Link></li>}
                                            {permitePonto === 'S' && <li><Link to={"/arbor/ponto/ocorrencias/"} className="dropdown-item"><i className="fa fa-clock-o" /> Ocorrências de ponto</Link></li>}
                                        </ul>
                                    </li>
                                    {/* 3. SUBMENU VENDAS */}
                                    {permiteVendas === 'S' && (
                                        <li className="dropdown-submenu">
                                            <a href="#" className="dropdown-item dropdown-toggle"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();

                                                    const currentItem = e.currentTarget.parentElement;
                                                    const submenu = e.currentTarget.nextElementSibling;

                                                    // fecha TODOS os outros submenus (menos o atual)
                                                    document.querySelectorAll(".dropdown-submenu").forEach((el) => {
                                                        if (el !== currentItem) {
                                                            el.classList.remove("open-left");
                                                            el.querySelector(".dropdown-menu")?.classList.remove("show");
                                                        }
                                                    });

                                                    // calcula espaço na tela
                                                    const rect = e.currentTarget.getBoundingClientRect();
                                                    const spaceRight = window.innerWidth - rect.right;

                                                    // decide direção
                                                    if (spaceRight < 250) {
                                                        currentItem.classList.add("open-left");
                                                    } else {
                                                        currentItem.classList.remove("open-left");
                                                    }

                                                    // 🔥 IMPORTANTE: alterna só o atual
                                                    submenu?.classList.toggle("show");
                                                }}>
                                                <i className="fa fa-line-chart" /> Vendas
                                            </a>
                                            <ul className="dropdown-menu">
                                                <li><Link to={"/arbor/vendas/secao/"} className="dropdown-item"><i className="fa fa-line-chart" /> Vendas - Departamento/Seção</Link></li>                                                
                                                <li><Link to={"/arbor/vendas/secao/compara"} className="dropdown-item"><i className="fa fa-line-chart" /> Vendas - Departamento/Seção Comparativo</Link></li>                                                                                                
                                                
                                                <li><Link to={"/arbor/vendas/comparativo/"} className="dropdown-item"><i className="fa fa-line-chart" /> Vendas - Comparativo</Link></li>
                                                <li><Link to={"/arbor/vendas/flash/"} className="dropdown-item"><i className="fa fa-bolt" /> Vendas - Flash</Link></li>
                                                <li><Link to={"/arbor/vendas/loja/"} className="dropdown-item"><i className="fa fa-line-chart" /> Vendas - Período Loja</Link></li>
                                                <li><Link to={"/arbor/vendas/mes/"} className="dropdown-item"><i className="fa fa-line-chart" /> Vendas - Período</Link></li>
                                                
                                            </ul>
                                        </li>
                                    )}


                                </ul>
                            </li>
                        )}

                        {/* Itens Externos */}
                        {(isSapOrArbor && !isRestrito || chapa === '900010') && (
                            <li className="nav-item">
                                <Link to={"/arbor/ouvidoria/"} className="nav-link"><i className="fa fa-deaf" /> Ouvidoria</Link>
                            </li>
                        )}

                        {!isRestrito && props.modulo === "SAP" && (
                            <li className="nav-item">
                                <Link to={"/arbor/sap/horario/"} className="nav-link"><i className="fa fa-clock-o" /> Horários</Link>
                            </li>
                        )}

                        {props.modulo !== "NOVO1" && (
                            <li className="nav-item">
                                <a href="/" onClick={Logout} className="nav-link"><i className="fa fa-sign-out" /> Sair</a>
                            </li>
                        )}
                    </ul>
                </div>
            </div>
        </nav>
    );
}

export default Menu;